__turbopack_context__.v({
  "buttonWrapper": "search-layout-module-scss-module__AlQY3G__buttonWrapper",
  "closeButton": "search-layout-module-scss-module__AlQY3G__closeButton",
  "controlWrapper": "search-layout-module-scss-module__AlQY3G__controlWrapper",
  "controls": "search-layout-module-scss-module__AlQY3G__controls",
  "filtersButton": "search-layout-module-scss-module__AlQY3G__filtersButton",
  "openControls": "search-layout-module-scss-module__AlQY3G__openControls",
  "results": "search-layout-module-scss-module__AlQY3G__results",
  "scrollingContainer": "search-layout-module-scss-module__AlQY3G__scrollingContainer",
  "wrapper": "search-layout-module-scss-module__AlQY3G__wrapper",
});
